import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "w100 posRe",
  style: {"padding":"0 10px","height":"60px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(`posAb pointer centered gradBlueBg popUpShadow`),
  style: {"width":"125px","height":"52px","border-radius":"24px","right":"0","top":"0"}
}
const _hoisted_4 = {
  class: "with_white_bg fl ml5 mt5",
  style: {"width":"42px","height":"42px","border-radius":"50%"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  class: "posAb",
  style: {"width":"20px","right":"-2px","top":"-2px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_AlertBadge = _resolveComponent("AlertBadge")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(`w100 ${_ctx.room && _ctx.rm.currentMessageRoom && _ctx.rm.currentMessageRoom.room_id == _ctx.room.room_id ? `selected` : ``}`),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectMessageRoom(_ctx.room)))
  }, [
    _createElementVNode("td", _hoisted_1, [
      (_ctx.room.isParent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/chat.png`),
                  width: "30",
                  height: "30",
                  class: "mt6"
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("p", {
                style: {"width":"70px"},
                class: _normalizeClass(`fl whiteColor fw800 fs15 text-left ml5 ${_ctx.attendees && _ctx.attendees.length > 1 ? `mt9` : `mt17`}`)
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t(`message.chat`)), 1),
                (_ctx.attendees && _ctx.attendees.length > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _hoisted_7,
                      _createTextVNode("（全員）")
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendees, (mem, memindex) => {
              return (_openBlock(), _createBlock(_component_UserIcon, {
                key: memindex,
                width: 48,
                canEdit: false,
                member: mem,
                class: "posAb",
                style: _normalizeStyle(`right:${memindex * 38}px;top:0;`),
                showTooltip: false
              }, null, 8, ["member", "style"]))
            }), 128))
          ])),
      _createElementVNode("p", _hoisted_9, [
        _createVNode(_component_AlertBadge, {
          num: _ctx.room.unread_num,
          display: `num`
        }, null, 8, ["num"])
      ])
    ])
  ], 2))
}